import {PlatformCommand, PlatformCommandResponse} from '@shared/commands/command-base';
import {EventStatus} from '@shared/models/notification-message.model';

/**
 * Orbitax Meet's licence (ITP-E-208-01, D-09): Start a Meet shows only to a user who holds it, and the server refuses
 * anyone else. It is the licence alone: the calls switch, which hides Voice call and Video call, does not hide it.
 */
export const MEET_FEATURE = 'OM';

/** A platform command does not fail on a lost connection, so a bounded wait stands in for one (as the calls' do). */
export const START_MEET_TIMEOUT_MS = 30000;

/** What the user reads when the server refused the start or never answered it. */
export const START_MEET_FAILED = 'The meeting could not be started.';

/** Whether the security store's `hasFeature` says the user holds Orbitax Meet. */
export function holdsMeet(hasFeature: ((id: string) => unknown) | null | undefined): boolean {
  return typeof hasFeature === 'function' && !!hasFeature(MEET_FEATURE);
}

/** `StartChatMeetingCommand` for one chat: the server makes a new Meet for its members and posts the meeting card. */
export function startChatMeetingCommand(conversationId: string): PlatformCommand {
  const command = new PlatformCommand('StartChatMeetingCommand', 'CollaborationApi');
  command.fieldValues = {ConversationId: conversationId};
  command.waitForResponse = true;
  return command;
}

/** The meeting the server started, or null when it refused or did not answer. */
export function startedMeetingId(response: PlatformCommandResponse | null | undefined): string | null {
  if (!response || response.status === EventStatus.Failed || !response.fieldValues) {
    return null;
  }
  return response.fieldValues['MeetId'] || null;
}

/** The server's word on a refused start ("Orbitax Meet is not available."), else the general one. */
export function startMeetError(response: PlatformCommandResponse | null | undefined): string {
  return response?.fieldValues?.['SnackBarMessage'] || response?.fieldValues?.['ErrorMessage'] || START_MEET_FAILED;
}
